import {ActivityTypesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'UPDATE_ACTIVITY_TYPES';

export async function updateActivityTypes(userData: Record<string, string>, activityTypesId: number | string, payload: Record<string, unknown>) {
    try {
        const result = await ActivityTypesDao.updateActivityTypes(userData, activityTypesId, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du type d\'activité',
            error: error
        });
    }
}
